import { MasterService } from '../services/master.service';
import axios from 'axios';
import config from "../config";
const {
  apiGateway: {ASSISTANT_INSTANCE,ASSISTANT_HISTORY },
} = config;
export const saveAssistantInstance = async (data, options = {}) => {
  try {
    return MasterService.post(`${ASSISTANT_INSTANCE}/saveinstance`, data, options);
  } catch (error) {
    throw error;
  }
};
export const ChatAssistantHistory = async (data, options = {}, token = null) => {
  try {
    if (token) {
      axios.defaults.headers.common['X-access-token'] = token;
    }
    return axios.post(ASSISTANT_HISTORY, data);
  } catch (error) {
    throw error;
  }
};

export const updateAssistantInstance = async (data, options = {}, token = null) => {
  try {
    if (token) {
      axios.defaults.headers.common['X-access-token'] = token;
    }
    return MasterService.post(`${ASSISTANT_INSTANCE}/instance/update`, data, options);
  } catch (error) {
    throw error;
  }
};

export const generateAssitantInstanceUUID = async (data, options = {}, token = null) => {
  try {
    if (token) {
      axios.defaults.headers.common['X-access-token'] = token;
    }
    return MasterService.post(`${ASSISTANT_INSTANCE}/instance/generate`, data, options);
  } catch (error) {
    throw error;
  }
};